import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

var api_path = "/php_scripts/";
if (process.env.NODE_ENV === 'development') {
  api_path = "http://localhost/php_scripts/";
} else {
}

export { 
  api_path as api_path
}

export default new Vuex.Store({
  state: {
    patientList: [],
    prisonList: [],
    patientSearchKey: "",
    testDefs: {},
    user: {
      name: "",
      access: ""
    }
  },
  getters: {
    patientCount: state => {
      return state.patientList.length
    },
    prisonCount: state => {
      return state.prisonList.length
    },
    getPatientList: state => {
      return state.patientList
    },
    getPatientByIndex: state => index => {
      return state.patientList[index];
    },
    findPatientByIdNumber: state => idNumber => {
      return state.patientList.find( patient => patient.id_number == idNumber )
    },
    findPatientById: state => id => {
      return state.patientList.find( patient => patient.patient_id == id )
    },
    getPrisonNameById: state => id => {
      return state.prisonList.find( prison => prison.prison_id == id ).name;
    },
    getTestDefById: state => id => {
      return state.testDefs["" + id]
    },
    getTestDefs: state => {
      return state.testDefs
    },
    getUserName: state =>{
      return state.user.name
    },
    getUserAccess: state => {
      return state.user.access
    },
    getUserLoggedIn: state => {
      return state.user.name !== ""
    },
    getIsprivilegedUser: state => {
      return state.user.access == "root" || state.user.access == "all"
    }
  },
  mutations: {
    UPDATE_PATIENT_LIST: function (state, patientList) {
      state.patientList = patientList
      console.log("patient list updated successfully. new length is: " + state.patientList.length)
    },
    UPDATE_PATIENT_SEARCH_KEY: function (state, newVal) {
      state.patientSearchKey = newVal;
      console.log("patient search key cached " + newVal);
    },
    UPDATE_PRISON_DATA: function (state, prisonList) {
      state.prisonList = prisonList;
      console.log("prison list updated " + prisonList);
    },
    UPDATE_TEST_DEFS: function(state, testDefs) {
      state.testDefs = testDefs;
    },
    UPDATE_USER: function(state, user){
      state.user = user
    }
  },
  actions: {
    LOGOUT: function(context){
      console.log("now logging out from store")
      return new Promise( (resolve) => {
        context.commit("UPDATE_USER", {name:"", access:""})
        resolve();
      } )
    },
    AUTH_USER: function ({ dispatch, commit }, credentials){
      console.log("auth user from the f** store" + credentials.login + " " + "unnamed password")
      return new Promise((resolve, reject)=>{
        axios.post(api_path + 'login.php', {
          data: {
            credentials
          }
        }).then((response)=>{
          console.log(response)
          if(response.data.status === "OK"){
            commit("UPDATE_USER", response.data.user)
            dispatch("FETCH_PATIENT_LIST");
            dispatch("FETCH_PRISON_DATA");
            dispatch("FETCH_TEST_DEFS");
            resolve("auth OK")
          } else if (response.data.status === "NO AUTH"){
            dispatch("LOGOUT").then( () => resolve("auth not OK") )
          }
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
      })
    },
    RESET_USER_PASSWORD: function(context,credentials){
      // console.log("reset password requested in store" + credentials.login + " " + "unnamed password")
      console.log("credentials is:")
      console.log(credentials)
      return new Promise((resolve, reject) => {
        axios.post(api_path + 'auth/login_reset_password.php', {
          data: {
            credentials
          }
        }).then((response)=>{
          console.log(response)
          if(response.data.status === "OK"){
            // commit("UPDATE_USER", response.data.user)
            resolve("reset OK")
          } else if (response.data.status === "not OK"){
            // dispatch("LOGOUT").then( () => resolve("reset not OK") )
            resolve("reset not OK")
          }
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
      })
    },
    FETCH_PATIENT_LIST: function (context) {
      axios.get(api_path + 'get_patient_list_json.php', {
        params:{
          accessString: this.getters.getUserAccess
        }
      }).then(function (response) {
        console.log("patient list fetched");
        console.log(response)
        context.commit('UPDATE_PATIENT_LIST', response.data)
      }).catch(function (error) {
        console.log(error)
      })
    },
    FETCH_PRISON_DATA: function (context) {
      axios
        .get(api_path + "get_prison_list_json.php")
        .then(function (response) {
          console.log("prison list fetched");
          console.log(response);
          context.commit('UPDATE_PRISON_DATA', response.data);
        }).catch(function (error) {
          console.log(error);
        });
      // context.commit('UPDATE_PRISON_DATA', response.data);
    },
    FETCH_TEST_DEFS: function (context){
      axios
        .get(api_path + "get_test_definitions_json.php")
        .then(function (response) {
          console.log("test defs fetched:")
          console.log(response);
          context.commit('UPDATE_TEST_DEFS', response.data.test_defs);
        }).catch(function (error) {
          console.log(error);
        });
      // context.commit('UPDATE_TEST_DEFS', response.data.test_defs);      
    },
    REMOVE_PATIENT: function ({ dispatch }, patient){
      console.log("store is removing patient with id:" + patient.patient_id)
      return new Promise((resolve, reject)=>{
        axios.post(api_path + 'remove_patient_by_id.php', {
          data: {
            patient_id: patient.patient_id
          }
        }).then((response)=>{
          console.log(response)
          if(response.data.status === "OK"){
            dispatch("FETCH_PATIENT_LIST")
          }
          resolve(response.data.result)
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
      })
      
    },
    REMOVE_TEST: function (context, test){
      console.log("store is removing test:")
      console.log(test)

      return new Promise((resolve, reject)=>{
        axios.post(api_path + 'remove_test_by_id.php', {
          data: {
            test_id: test.test_id
          }
        }).then((response)=>{
          console.log(response)
          resolve(response.data.result)
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
      })
    },
    GET_DOCTOR_NAMES: function (context){
      console.log("getting doctor names:")

      return new Promise((resolve, reject)=>{
        axios.get(api_path + 'get_doctor_names.php')
          .then(response=>{
            console.log(response)
            resolve(response.data)
          })
          .catch(error=>{
            console.log(error)
            reject(error)
          })
      })
    },
    GET_STATS: function (start_date, end_date){
      console.log("getting stats:")
      console.log("date:" + start_date + " to " + end_date )
      console.log(start_date)
      return new Promise((resolve, reject)=>{
        axios.get(api_path + 'get_stats_json.php', {
          data:{
            start_date: start_date,
            end_date: end_date
          }
        })
          .then(response=>{
            console.log(response)
            resolve(response.data)
          })
          .catch(error=>{
            console.log(error)
            reject(error)
          })
      })
    },
    SAVE_COVID_TEST: function (context, testData) {
      console.log('save covid data:', testData);
      return new Promise((resolve, reject) => {
        axios.post(api_path + 'save_covid_test.php', {
          data: {
            patient_id: testData.patientId,
            test_data: JSON.stringify(testData),
          }
        })
          .then(response=>{
            console.log(response)
            resolve(response.data)
          })
          .catch(error=>{
            console.log(error)
            reject(error)
          })
      })
    },
    UPDATE_COVID_TEST: function (context, testData) {
      console.log('save covid data:', testData);
      return new Promise((resolve, reject) => {
        axios.post(api_path + 'update_covid_test.php', {
          data: {
            test_id: testData.testId,
            test_data: JSON.stringify(testData),
          }
        })
          .then(response=>{
            console.log(response)
            resolve(response.data)
          })
          .catch(error=>{
            console.log(error)
            reject(error)
          })
      })
    },
    GET_COVID_TEST: function (context, test_id) {
      console.log('shoud get covid test with id: ',  test_id)
      return new Promise((resolve, reject)=>{
        axios.get(api_path + 'get_covit_test_by_test_id.php', {
          data:{
            test_id: test_id,
          }
        })
          .then(response=>{
            console.log(response)
            resolve(response.data)
          })
          .catch(error=>{
            console.log(error)
            reject(error)
          })
      })
    },
    GET_COVID_TESTS: function (context, patient_id) {
      console.log('shoud get covid test with id: ',  test_id)
      return new Promise((resolve, reject)=>{
        axios.get(api_path + 'get_covit_test_by_patient_id.php', {
          data:{
            patient_id: patient_id,
          }
        })
          .then(response=>{
            console.log(response)
            resolve(response.data)
          })
          .catch(error=>{
            console.log(error)
            reject(error)
          })
      })
    },
  }
})
